export default [
  {
    headerLabel: 'delimit.report.table.requestDate',
    type: 'datetime',
    field: 'creatTs',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'delimit.report.table.store',
    type: 'general',
    field: 'branch',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'lm_label',
    type: 'general',
    field: 'lmCode',
    className: 'align-right',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'reports.description',
    type: 'general',
    field: 'productName',
    render: true,
    fixed: true,
  },
  {
    headerLabel: 'delimit.report.table.section',
    type: 'general',
    field: 'section',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'order.quantity_label',
    type: 'decimal2',
    field: 'quantity',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.cmup',
    type: 'general',
    field: 'cmup',
    className: 'align-right',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.statusType',
    type: 'general',
    field: 'tipStatus',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.requester',
    type: 'general',
    field: 'requester',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.approver',
    type: 'general',
    field: 'approver',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.dthApproved.new',
    type: 'datetime',
    field: 'dthApproved',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.txtResponseCreate',
    type: 'general',
    field: 'justifyName',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'demarcate.report.table.reproveReason',
    type: 'general',
    field: 'reproveReason',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.depositOrigin',
    type: 'general',
    field: 'depositOrigin',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.revenueLdap',
    type: 'general',
    field: 'revenuesLdap',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.invoiceTimestamp',
    type: 'datetime',
    field: 'invoiceTimestamp',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'delimit.report.table.invoiceNumber.new',
    type: 'general',
    field: 'invoiceNumber',
    render: true,
    fixed: false,
  },
]
